import { Group, Paper, Stack } from '@common/ui'
import TrimmedTextInput from './TrimmedTextInput'
import { com, kotlin } from '@eidu/web'
import ItemList from './ItemList'
import { withKey } from '../../util/withKey'
import FormKeyField from './FormKeyField'
import Section = com.eidu.sharedlib.form.definition.Section
import Item = com.eidu.sharedlib.form.definition.Item
import KtList = kotlin.collections.KtList

type SectionItemProps = {
  item: Section
  onChange?: (item: Section) => void
}

const SectionItem: React.FC<SectionItemProps> = ({ item, onChange }) => {
  const handleItemsChange = (newItems: KtList<Item>) => {
    onChange?.(withKey(item.copy(item.title, item.key, newItems), item))
  }

  return (
    <Paper withBorder radius="sm" p="xs">
      <Stack gap="md">
        <Group gap="md" wrap="nowrap">
          <TrimmedTextInput
            style={{ flex: 1 }}
            label="Title"
            value={item.title}
            onChange={(e) => onChange?.(withKey(item.copy(e.target.value, item.key, item.items), item))}
            disabled={!onChange}
          />
          <FormKeyField
            value={item.key}
            onChange={(e) => onChange?.(withKey(item.copy(item.title, e.target.value, item.items), item))}
            disabled={!onChange}
          />
        </Group>
        <Paper radius="sm" p="xs" bg="var(--trellis-color-surface)">
          <ItemList items={item.items} onChange={onChange && handleItemsChange} />
        </Paper>
      </Stack>
    </Paper>
  )
}

export default SectionItem
